<template>
  <div class="outer">
    <div class="introduction">

      <div class="profile" :class="inAnimation ? 'Anims' : ''" @animationend="animationend">
        <div class="title">
          <div class="chinese">公司简介</div>
          <div class="english">COMPANY PROFILE</div>
        </div>
        <div v-html="showData.introduction"></div>
        <div class="more" @click="toMore()">
          {{ showData.moreName }}
          <img class="icon" src="@/assets/img/icon/more.png" />
        </div>
        <div class="aword">
          <div class="item">
            <img src="@/assets/img/icon/icon_pro.jpg" />
            <div>
              <span id="firstNum1">{{ showData.awards }}</span><span>{{ isEnglish ? 'Top' : '强' }}</span>
              <div class="mleft">{{ showData.geographicTitle || (isEnglish ? 'China Geographic Information Industry' : '中国地理信息产业') }}</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/img/icon/icon_pro2.jpg" />
            <div>
              <span id="firstNum1">{{ showData.awards }}</span><span>{{ isEnglish ? '+' : '余项' }}</span>
              <div class="mleft">{{ showData.awardsTitle || (isEnglish ? 'National and Provincial Awards' : '国家和省部奖项') }}</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/img/icon/icon_pro3.jpg" />
            <div>
              <span id="firstNum2">{{ showData.copyrights }}</span><span>{{ isEnglish ? '+' : '余项' }}</span>
              <div class="mleft">{{ showData.copyrightsTitle || (isEnglish ? 'Patents and Copyrights' : '专利及著作权') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: "Introduction",
  props: {
    inAnimation: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      honorNumArr: [0, 0, 0],
      showData: {
        introduction: '',
        moreName: '',
        geographic: '',
        awards: '',
        copyrights: '',
        geographicTitle: '',
        awardsTitle: '',
        copyrightsTitle: '',
        url: '',
      },
    };
  },
  computed: {
    isEnglish() {
      return this.$store.state.language === 'English'
    },
  },
  // watch: {
  //   inAnimation(val) {
  //     if (val) {
  //       this.increaseNumber();
  //     }
  //   },
  //   immediate: true,
  // },
  watch: {
    list: {
      handler(val) {
        if (val.length == 1) {
          let item = val[0]
          this.showData.introduction = item.keyValue
          this.showData.moreName = '查看更多'
          this.showData.geographic = item.keyEnName
          this.showData.awards = item.keyName
          this.showData.copyrights = item.typeName
          this.$forceUpdate()
        } else {
          val.map(item => {
            if (item.keyName == '公司简介') {
              this.showData.introduction = item.keyValue
            } else if (item.keyName == '查看更多') {
              this.showData.moreName = item.keyValue
              this.showData.url = item.url
            } else if (item.typeName == '中国地理信息产业') {
              this.showData.geographic = item.keyValue
              this.showData.geographicTitle = item.keyName
            } else if (item.typeName == '国家和省部奖项') {
              this.showData.awards = item.keyValue
              this.showData.awardsTitle = item.keyName
            } else if (item.typeName == '专利及著作权') {
              this.showData.copyrights = item.keyValue
              this.showData.copyrightsTitle = item.keyName
            }
          })
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    // this.increaseNumber();
  },
  methods: {
    increaseNumber() {
      let that = this;
      that.honorNumArr = [0, 0, 0];
      let targetNumArr = [50, 40, 230];
      var countEl = document.getElementById("firstNum");
      var countEl1 = document.getElementById("firstNum1");
      var countEl2 = document.getElementById("firstNum2");
      let timer = setInterval(() => {
        that.honorNumArr[0] >= targetNumArr[0] ? "" : that.honorNumArr[0] += 2;
        that.honorNumArr[1] >= targetNumArr[1] ? "" : that.honorNumArr[1] += 2;
        that.honorNumArr[2] >= targetNumArr[2] ? "" : that.honorNumArr[2] += 6;
        if (that.honorNumArr[0] < targetNumArr[0]) {
          countEl.innerHTML = that.honorNumArr[0];
          countEl1.innerHTML = that.honorNumArr[1];
          countEl2.innerHTML = that.honorNumArr[2];
        } else {
          countEl.innerHTML = targetNumArr[0];
          countEl1.innerHTML = targetNumArr[1];
          countEl2.innerHTML = targetNumArr[2];
          clearInterval(timer);
        }
      }, 70);
    },
    animationend() {
      this.$emit("animationend");
    },
    toMore() {
      let url = this.showData.url || '/about'
      this.$router.push(url)
      // this.$router.push('/about')
      // this.$router.push(this.$store.state.localLink)
    }
  },
};
</script>
  
<style lang="scss" scoped>
.outer {
  max-height: 100vh;
  overflow: hidden;
}

.introduction {
  width: 100%;
  height: 100vh;
  background: url(../../assets/img/profile_bg.jpg) no-repeat center;
  background-size: cover;
  overflow: hidden;
  text-align: left;
  position: relative;
  top: 0;

  .Anims {
    animation: fadeInLeft;
    /* referring directly to the animation's @keyframe declaration */
    animation-duration: 2s;
    /* don't forget to set a duration! */
  }

  .profile {
    width: 1150px;
    padding: 160px 0 0 160px;

    .title {
      font-size: 28px;
      font-weight: bold;
      color: #024094;
      line-height: 41px;
      text-align: center;
    }

    p {
      width: 100%;
      line-height: 31px;
      text-indent: 2em;
    }

    .more {
      margin: 30px 0 50px 670px;
      width: 129px;
      height: 52px;
      background: #dc000c;
      border-radius: 6px;
      font-size: 14px;
      text-align: center;
      font-family: Source Han Sans CN;
      color: #ffffff;
      line-height: 52px;
      cursor: pointer;

      .icon {
        width: 16px;
        margin-left: 10px;
      }
    }

    .more:hover {
      font-weight: 900;
      font-size: 16px;
    }

    .aword {
      width: 800px;
      display: flex;
      justify-content: space-between;

      .item {
        text-align: left;
        display: flex;

        img {
          width: 39px;
          height: 39px;
          margin-right: 20px;
          margin-top: 8px;
        }

        span {
          font-size: 40px;
          font-weight: bold;
          margin: 0 10px;
          color: #dc000c;
          &:nth-child(2){
            font-size: 16px;
          }
        }


        .mleft {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
  
